export default __webpack_public_path__ + "static/media/image1.9158dcb6.png";